import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import '../Style/OrderForm.css';
import { useTranslation } from 'react-i18next';

const OrderForm = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { stone, selectedImage } = location.state || {};

  const [length, setLength] = useState('');
  const [width, setWidth] = useState('');
  const [thickness, setThickness] = useState('');
  const [quantity, setQuantity] = useState('');
  const [quantityType, setQuantityType] = useState('linear');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const { addToCart } = useCart();

  const getLocalizedText = (obj) => {
    if (!obj) return '';
    return typeof obj[i18n.language] === 'string' ? obj[i18n.language] : '';
  };

  const imageName = selectedImage ? getLocalizedText(selectedImage.name) : '';

  useEffect(() => {
    if (!stone) {
      setErrorMessage(t('error.noStoneSelected'));
    }
  }, [stone, t]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!length || !width || !thickness || !quantity) {
      setErrorMessage(t('error.fillAllFields'));
      setSuccessMessage('');
      return;
    }

    const orderItem = {
      label: stone.label,
      src2: selectedImage ? selectedImage.src : stone.src2,
      imageName: imageName,
      length: parseFloat(length),
      width: parseFloat(width),
      thickness: parseFloat(thickness),
      quantity: parseInt(quantity),
      quantityType,
    };

    addToCart(orderItem);
    setSuccessMessage(t('success.orderAdded'));
    setErrorMessage('');
    setLength('');
    setWidth('');
    setThickness('');
    setQuantity('');
    setQuantityType('linear');
  };

  if (!stone) {
    return <div>{t('error.noStoneSelected')}</div>;
  }

  return (
    <div style={{ backgroundColor: '#f0f2f5', minHeight: '100vh', padding: '20px' }}>
      <div className="stone-dimensions">
        <h2>{stone.label}</h2>

        {selectedImage && (
          <div className="selected-image-preview" style={{ textAlign: 'center', marginBottom: '20px' }}>
            <img
              src={selectedImage.src}
              alt={imageName}
              style={{ maxWidth: '200px', borderRadius: '8px' }}
            />
            <p style={{ marginTop: '8px', fontWeight: 'bold' }}>{imageName}</p>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <label>
            {t('Length (cm):')}
            <input type="number" min="0" value={length} onChange={(e) => setLength(e.target.value)} />
          </label>
          <label>
            {t('Width (cm):')}
            <input type="number" min="0" value={width} onChange={(e) => setWidth(e.target.value)} />
          </label>
          <label>
            {t('Thickness (cm):')}
            <input type="number" min="0" value={thickness} onChange={(e) => setThickness(e.target.value)} />
          </label>
          <label>
            {t('Quantity (m):')}
            <input type="number" min="0" value={quantity} onChange={(e) => setQuantity(e.target.value)} />
          </label>

          <div className="radio-group">
            <label>
              <input
                type="radio"
                name="quantity-type"
                value="linear"
                checked={quantityType === 'linear'}
                onChange={(e) => setQuantityType(e.target.value)}
              />
              {t('Linear meter')}
            </label>
            <label>
              <input
                type="radio"
                name="quantity-type"
                value="square"
                checked={quantityType === 'square'}
                onChange={(e) => setQuantityType(e.target.value)}
              />
              {t('Square meter')}
            </label>
          </div>

          <div className="stone-actions">
            <button type="submit">{t('Submit Order')}</button>
          </div>
        </form>

        {errorMessage && (
          <div className="error-message">{errorMessage}</div>
        )}

        {successMessage && (
          <div className="success-message">{successMessage}</div>
        )}
      </div>
    </div>
  );
};

export default OrderForm;
